import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.get("/api/measureacl", { params });
};


const upsert = data => {
  return restApi.post("/api/measureacl", data);
};

const remove = ids => {
  return restApi.delete(`/api/measureacl/${ids}`);
};

const measureAclService = {
  getAll,
  upsert,
  remove
};

export default measureAclService;